export default "__VITE_ASSET__e161a5cf__"